import { useSearchParams } from 'react-router-dom';
import NewPasswordPage from './NewPasswordPage';
import RecoverPasswordPage from './RecoverPasswordPage';
import './RecoverPasswordPage.scss';

const RecoverPasswordWrapper = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('recoverytoken');

  if (!token) {
    return <RecoverPasswordPage />;
  }

  return <NewPasswordPage token={token} />;
};

export default RecoverPasswordWrapper;
